<template>
  <div class="register">

    <el-container>
      <!-- <el-header>
        <div class="topfont">
          <h2>欢迎注册</h2>
        </div>
      </el-header> -->
  <el-main>
        <div class="registermain">
          <div class="topfont">
          <h2>欢迎注册</h2>
        </div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="formClass">
            <div class="inpit_main">
            <el-form-item label="用户名" prop="username">
              <el-input v-model="ruleForm.username"></el-input>
            </el-form-item>

            <el-form-item label="密 码" prop="pwd">
              <el-input v-model="ruleForm.pwd"></el-input>
            </el-form-item>
            <el-form-item label="姓 名" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="年 龄" prop="age">
              <el-input v-model="ruleForm.age"></el-input>
            </el-form-item>
            <el-form-item label="用户类别" prop="type">
              <el-radio-group v-model="ruleForm.type">
                <el-radio label="1">我是学生</el-radio>
                <el-radio label="0">我是老师</el-radio>
                <el-radio label="3">我是家长</el-radio>
                <el-radio label="5">我是辅导员</el-radio>
                <el-radio label="6">我是行政人员</el-radio>
                <el-radio label="7">我是专业老师</el-radio>

              </el-radio-group>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="ruleForm.sex">
                <el-radio label="男">男</el-radio>
                <el-radio label="女">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="家庭住址" prop="address">
<v-distpicker @selected="onSelect"  v-model="ruleForm.address"></v-distpicker>
  </el-form-item>
  <el-form-item label="详细地址" prop="address">
<el-input  v-model="ruleForm.address" ></el-input>
</el-form-item>
            <el-form-item label="学生ID" prop="studentID" v-if="ruleForm.type==3">
              <el-input v-model="ruleForm.studentID" type="number" oninput="if(value.length>9)value=value.slice(0,9)">
              </el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="mobiles">
              <el-input v-model="ruleForm.mobiles" type="number" oninput="if(value.length>11)value=value.slice(0,11)">
                <el-button slot="append" @click="SendMessage()" v-if="!sendPower">点击发送验证码</el-button>
            <el-button slot="append" v-if="sendPower">请于{{ time }}秒后重试</el-button>
              </el-input> 
              <!-- <button @click="SendMessage()" :disabled="sendPower">点击发送验证码</button><span
                v-if="sendPower">请于{{time}}秒后重试</span> -->
            </el-form-item>

            <el-form-item label="验证码" prop="authCode">
              <el-input type="number" oninput="if(value.length>6)value=value.slice(0,6)" v-model="ruleForm.authCode">
              </el-input>

            </el-form-item>
            <div class="buttonClass">
              <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
              </el-form-item>
            </div>
          </div>
          </el-form>
        </div>
      </el-main>
    </el-container>





  </div>
</template>

<script>
import { checkMobiles, checkStudentID, checkUsername ,checkPassword} from '@/components/work/until/vaildate.js'
import VDistpicker from 'v-distpicker'
export default {
   components: { VDistpicker },
  data() {
    return {
      citydata:'',
      sendPower: false,
      time: '',
      ruleForm: {
        username: '',
        password: '',
        name: '',
        age: '',
        sex:'',
        type: '',
        studentID: '',
        address:'',
        mobiles: '',
        authCode: '',
        pwd: '',
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { validator: checkUsername, trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择用户类别', trigger: 'blur' },
        ], studentID: [
          { required: true, message: '输入学生ID', trigger: 'blur' },
          { validator: checkStudentID, trigger: 'blur' }
        ],
        mobiles: [
          { required: true, message: '手机号', trigger: 'blur' },
          { validator: checkMobiles, trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator:checkPassword , trigger: 'blur' }
        ],
        authCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 6, max: 6, message: '长度为6位数字', trigger: 'blur' }
        ],
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(valid)
          const formData = new FormData()
          formData.append("username", this.ruleForm.username)
          formData.append('password', window.btoa(this.ruleForm.pwd))
          formData.append('name', this.ruleForm.name)
          formData.append('age', this.ruleForm.age)
          formData.append('sex', this.ruleForm.sex)
          formData.append('address', this.ruleForm.address)
          formData.append('type', this.ruleForm.type)
          formData.append('studentID', this.ruleForm.studentID)
          formData.append('mobiles', this.ruleForm.mobiles)
          formData.append('authCode', this.ruleForm.authCode)
          let config = {
            headers: { "Content-Type": "application/json;charset=utf-8" }
          };
          this.axios.post("/user/insertUsers", formData, config)
            .then(resp => {
              if (resp.data.status == 1) {
                this.$message({
                  message: '注册成功',
                  type: 'success'
                })
                this.$router.push({ name: 'Login' });

              } else {
                console.log(resp.data)
                this.$message.error(resp.data.message)
              }
            })
            .catch((err) => {
              alert(err.message)
              console.log(err)
            })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },     onSelect: function(data) {
          this.citydata = data.province.value + data.city.value + data.area.value;
          this.ruleForm.address=this.citydata
          console.log(this.citydata);
          //alert(this.userForm.address)
        },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    SendMessage() {
      this.$refs.ruleForm.validateField('mobiles', valid => {
        if (valid) {
          return
        }
    
        this.setTime(60)
        this.setSendCodeLoadingStat(true)
        this.axios.post("/user/SendMessage?mobiles=" + this.ruleForm.mobiles+"&username="+ this.ruleForm.username)
          .then(resp => {
            if (resp.data.status == 1) {
              this.$message.success("发送成功")
            } else {
              this.$message.error("发送失败")
              this.$message.error(resp.data.message)
              console.log(resp.data.result)
            }
          })
          .catch((err) => {
            // alert("出错了")
            console.log(err)
          })

      })

    },
    setTime(val) {
      this.time = val.toString()
      if (val == 0) {
        //当发送定时器结果为0
        this.setSendCodeLoadingStat(false)
        return
      } else {
        val--
      }
      setTimeout(res => {
        //设置一个定时器，每秒刷新一次
        this.setTime(val)
      }, 1000)
    },
    setSendCodeLoadingStat(state) {
      //发送验证码时的加载动画显示
      this.sendPower = state //更改按钮是否可以点击 true为不可点击
    },
  }
}
</script>

<style scoped>
el-header {
  width: 100%;
}

.topfont {
  width: 500px;
  margin: auto;
  text-align: center;
}

.registermain {
  width: 100%;
  margin: auto;
  /* background-color: #f1f2f4; */
  opacity: 0.9;
}

.buttonClass {
  text-align: center;
}

.register {
  width: 100%;
  height: 100%;
  background-image: url('http://www.ebookware.cn/video/thu_saw.jpg');
  /* opacity: 0.9; */
  background-size: cover;
  margin: auto;
  /* background-image: url(https://sso.xjtlu.edu.cn/newLogin/images/logoBg.png); */

}
.formClass{
  width: 40%;
  margin: auto;
  margin-top: 2%;
  background-color: #f1f2f4;
  opacity: 0.9;
  /* text-align: center;
  margin: auto; */
}

.inpit_main{
width: 98%;
margin: auto;
padding-top: 4%;
padding-bottom: 2%;
}
.el-input{
  width: 95%;
}
</style>


// WEBPACK FOOTER //
// src/components/work/register.vue